export const InsertPanelIcons = {
  flow: 'y',
  width: '100%',
  gap: 'C',
  overflowY: 'auto',
  LibraryNavbar: {},
  Flex: {
    flow: 'y',
    gap: 'B',
    IconsGroup: {
      limit: 1000,
      childProps: {
        padding: 'auto',
        Icon: {
          fontSize: 'A',
        },
      },
    },
    padding: 'A',
  },
};